<app-orders-nav [activeMenuItem]="'pending_extensions'"></app-orders-nav>

<mat-card class="content-card">

  <h2>Pending card extensions</h2>

  <a mat-raised-button color="turquoise" [disabled]="pendingExtensions == null || pendingExtensions.length == 0 || isExecutingPendingExtensions" (click)="executeExtensions()" [class.spinner]="isExecutingPendingExtensions" >Execute Pending Extensions</a><br />
  <div style="margin-top: 5px;"><small>This will execute all pending card extensions and order the new plastic cards to be produced, if physical</small></div>

  <div class="header" fxLayout="row wrap" fxLayoutAlign="flex-start center" fxLayoutGap="20px">

  </div>

  <mat-table [dataSource]="pendingExtensions">
    <ng-container matColumnDef="customer">
      <mat-header-cell *matHeaderCellDef>Customer</mat-header-cell>
      <mat-cell *matCellDef="let extension">
        <a style="text-decoration: none;" [routerLink]="'../customers-overview/' + extension.card.customerId"><mat-icon>visibility</mat-icon> {{extension.card.cardName}}</a>
      </mat-cell>
    </ng-container>
    <ng-container matColumnDef="token">
      <mat-header-cell *matHeaderCellDef> Token </mat-header-cell>
      <mat-cell *matCellDef="let extension"> {{extension.card.token }} </mat-cell>
    </ng-container>

    <ng-container matColumnDef="cardType">
      <mat-header-cell *matHeaderCellDef> Type </mat-header-cell>
      <mat-cell *matCellDef="let extension">
        <div *ngIf="extension.card.cardType === 1 || extension.card.cardType === 3" style="background-color: grey; color: white; border-radius: 5px; font-weight: bold; padding: 4px;">Virtual</div>
        <div *ngIf="extension.card.cardType === 2" style="background-color: grey; color: white; border-radius: 5px; font-weight: bold; padding: 4px;">Physical</div>

      </mat-cell>
    </ng-container>

    <ng-container matColumnDef="date">
      <mat-header-cell *matHeaderCellDef> Date </mat-header-cell>
      <mat-cell *matCellDef="let extension"> {{extension.extensionDate| date: 'dd.MM.yyyy'}} </mat-cell>
    </ng-container>

    <ng-container matColumnDef="exp">
      <mat-header-cell *matHeaderCellDef> Exp </mat-header-cell>
      <mat-cell *matCellDef="let extension"> {{extension.oldExpiryDate != null ? (extension.oldExpiryDate | date: 'MM/yy') : 'unknown'}} </mat-cell>
    </ng-container>

    <ng-container matColumnDef="status">
      <mat-header-cell *matHeaderCellDef> Status </mat-header-cell>
      <mat-cell *matCellDef="let extension">
        <div *ngIf="extension.status === 1" style="background-color: grey; color: white; border-radius: 5px; font-weight: bold; padding: 4px;">Pending</div>
        <div *ngIf="extension.status === 2" style="background-color: orange; color: white; border-radius: 5px; font-weight: bold; padding: 4px;">Waiting for execution</div>
        <div *ngIf="extension.status === 3" style="background-color: dodgerblue; color: white; border-radius: 5px; font-weight: bold; padding: 4px;">Executed</div>
        <div *ngIf="extension.status === 4" style="background-color: forestgreen; color: white; border-radius: 5px; font-weight: bold; padding: 4px;">Activated</div>
        <div *ngIf="extension.status === 9" style="background-color: red; color: white; border-radius: 5px; font-weight: bold; padding: 4px;">Failed</div>
      </mat-cell>
    </ng-container>


    <mat-header-row *matHeaderRowDef="['customer', 'date', 'token', 'cardType', 'exp', 'status']"></mat-header-row>
    <mat-row *matRowDef="let row; columns: ['customer', 'date', 'token', 'cardType', 'exp', 'status']"></mat-row>

  </mat-table>


</mat-card>


<mat-card class="content-card">

  <h2>Recent card extensions</h2>

  <div style="margin-top: 5px;"><small>These are the last 500 processed card extensions</small></div>


  <mat-table [dataSource]="recentExtensions">
    <ng-container matColumnDef="customer">
      <mat-header-cell *matHeaderCellDef>Customer</mat-header-cell>
      <mat-cell *matCellDef="let extension">
        <a style="text-decoration: none;" [routerLink]="'../customers-overview/' + extension.card.customerId"><mat-icon>visibility</mat-icon> {{extension.card.cardName}}</a>
      </mat-cell>
    </ng-container>
    <ng-container matColumnDef="token">
      <mat-header-cell *matHeaderCellDef> Token </mat-header-cell>
      <mat-cell *matCellDef="let extension"> {{extension.card.token }} </mat-cell>
    </ng-container>

    <ng-container matColumnDef="cardType">
      <mat-header-cell *matHeaderCellDef> Type </mat-header-cell>
      <mat-cell *matCellDef="let extension">
        <div *ngIf="extension.card.cardType === 1 || extension.card.cardType === 3" style="background-color: grey; color: white; border-radius: 5px; font-weight: bold; padding: 4px;">Virtual</div>
        <div *ngIf="extension.card.cardType === 2" style="background-color: grey; color: white; border-radius: 5px; font-weight: bold; padding: 4px;">Physical</div>

      </mat-cell>
    </ng-container>

    <ng-container matColumnDef="date">
      <mat-header-cell *matHeaderCellDef> Date </mat-header-cell>
      <mat-cell *matCellDef="let extension"> {{extension.extensionDate| date: 'dd.MM.yyyy'}} </mat-cell>
    </ng-container>

    <ng-container matColumnDef="exp">
      <mat-header-cell *matHeaderCellDef> Exp </mat-header-cell>
      <mat-cell *matCellDef="let extension"> {{extension.oldExpiryDate != null ? (extension.oldExpiryDate | date: 'MM/yy') : 'unknown'}} </mat-cell>
    </ng-container>

    <ng-container matColumnDef="status">
      <mat-header-cell *matHeaderCellDef> Status </mat-header-cell>
      <mat-cell *matCellDef="let extension">
        <div *ngIf="extension.status === 1" style="background-color: grey; color: white; border-radius: 5px; font-weight: bold; padding: 4px;">Pending</div>
        <div *ngIf="extension.status === 2" style="background-color: orange; color: white; border-radius: 5px; font-weight: bold; padding: 4px;">Waiting for execution</div>
        <div *ngIf="extension.status === 3" style="background-color: dodgerblue; color: white; border-radius: 5px; font-weight: bold; padding: 4px;">Executed</div>
        <div *ngIf="extension.status === 4" style="background-color: forestgreen; color: white; border-radius: 5px; font-weight: bold; padding: 4px;">Activated</div>
        <div *ngIf="extension.status === 9" style="background-color: red; color: white; border-radius: 5px; font-weight: bold; padding: 4px;">Failed</div>
      </mat-cell>
    </ng-container>


    <mat-header-row *matHeaderRowDef="['customer', 'date', 'token', 'cardType', 'exp', 'status']"></mat-header-row>
    <mat-row *matRowDef="let row; columns: ['customer', 'date', 'token', 'cardType', 'exp', 'status']"></mat-row>
  </mat-table>


</mat-card>

